/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FeedbackRequestDto } from '../models/FeedbackRequestDto';
import type { FeedbackResponseDto } from '../models/FeedbackResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FeedbackControllerService {

    /**
     * Получение отзыва по id
     * @param id
     * @returns FeedbackResponseDto Отзыв успешно получен
     * @throws ApiError
     */
    public static findFeedbackById(
        id: number,
    ): CancelablePromise<FeedbackResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/feedbacks/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Отзыв не найден`,
            },
        });
    }

    /**
     * Обновление отзыва
     * @param id
     * @param requestBody
     * @returns FeedbackResponseDto Отзыв успешно обновлен
     * @throws ApiError
     */
    public static updateFeedback(
        id: number,
        requestBody: FeedbackRequestDto,
    ): CancelablePromise<FeedbackResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/feedbacks/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Некорректные данные`,
                404: `Отзыв не найден`,
            },
        });
    }

    /**
     * Удаление отзыва
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteFeedback(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/feedbacks/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Отзыв не найден`,
            },
        });
    }

    /**
     * Получение списка всех отзывов
     * @returns FeedbackResponseDto Отзывы успешно получены
     * @throws ApiError
     */
    public static findAllFeedbacks(): CancelablePromise<Array<FeedbackResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/feedbacks',
        });
    }

    /**
     * Создание отзыва
     * @param requestBody
     * @returns FeedbackResponseDto Отзыв успешно создан
     * @throws ApiError
     */
    public static createFeedback(
        requestBody: FeedbackRequestDto,
    ): CancelablePromise<FeedbackResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/feedbacks',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Некорректные данные`,
                404: `Пользователь не найден`,
            },
        });
    }

    /**
     * Получение отзывов по id пользователя
     * @param userId
     * @returns FeedbackResponseDto Отзывы пользователя успешно получены
     * @throws ApiError
     */
    public static findFeedbacksByUserId(
        userId: number,
    ): CancelablePromise<Array<FeedbackResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/feedbacks/user/{userId}',
            path: {
                'userId': userId,
            },
        });
    }

}
